import { AnalyticEventFields } from 'components/client-events/client-event-provider';

const CATEGORY = 'interim-dashboard-widget';

export const clickedButton = (): AnalyticEventFields => ({
  category: CATEGORY,
  action: 'clicked button',
});
